module.exports = __webpack_public_path__ + "img/oneclose-door.be5f24cd.png";